export const screenshots = [
  {
    src: '/screenshots/timeline.png?v=20251117',
    title: 'Explore Memory Trends',
    description: 'Track memory usage trends across commits with interactive charts'
  },
  {
    src: '/screenshots/ci_gate.png?v=20251117',
    title: 'CI Integration',
    description: 'Automatically update the dashboard and fail builds that exceed memory budgets'
  },
  {
    src: '/screenshots/compare.png?v=20251117',
    title: 'Compare Builds',
    description: 'Compare any two builds to see exactly how the memory footprint differs'
  },
  {
    src: '/screenshots/symbols.png?v=20251117',
    title: 'Investigate Memory Usage',
    description: 'Drill down into the memory footprint with symbol-level breakdowns'
  },
  {
    src: '/screenshots/budgets.png?v=20251117',
    title: 'Set Memory Budgets',
    description: 'Set and monitor memory usage budgets per feature'
  },
  {
    src: '/screenshots/commit_history.png?v=20251117',
    title: 'Check Commit History',
    description: 'Link memory changes directly to Git commits'
  }

];
